export const SET_DOMAINS_LIST = 'SET_DOMAINS_LIST';
